export default __webpack_public_path__ + "media/src/assets/images/activeExpand-fbf579a5d404436cc3cfa14f3441812f.png";